import { useCallback, useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

const CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // no ambiguous 0/O, 1/I

function randomCode(len = 5) {
  let out = "";
  for (let i = 0; i < len; i++) out += CHARS[Math.floor(Math.random() * CHARS.length)];
  return out;
}

function draw(canvas, text) {
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  const w = canvas.width, h = canvas.height;
  ctx.clearRect(0, 0, w, h);
  ctx.fillStyle = "#FEF9E7";
  ctx.fillRect(0, 0, w, h);

  for (let i = 0; i < 6; i++) {
    ctx.strokeStyle = `rgba(10,10,10,${0.15 + Math.random() * 0.2})`;
    ctx.beginPath();
    ctx.moveTo(Math.random() * w, Math.random() * h);
    ctx.lineTo(Math.random() * w, Math.random() * h);
    ctx.stroke();
  }
  for (let i = 0; i < 40; i++) {
    ctx.fillStyle = `rgba(10,10,10,${0.1 + Math.random() * 0.2})`;
    ctx.beginPath();
    ctx.arc(Math.random() * w, Math.random() * h, 1.2, 0, Math.PI * 2);
    ctx.fill();
  }

  const charWidth = w / text.length;
  [...text].forEach((ch, i) => {
    ctx.save();
    ctx.translate(charWidth * i + charWidth / 2, h / 2);
    ctx.rotate((Math.random() - 0.5) * 0.5);
    ctx.font = `bold ${Math.floor(h * 0.55)}px 'Space Grotesk', sans-serif`;
    ctx.fillStyle = "#0A0A0A";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(ch, 0, 0);
    ctx.restore();
  });
}

export default function Captcha({ onChangeValid }) {
  const canvasRef = useRef(null);
  const [code, setCode] = useState("");
  const [input, setInput] = useState("");

  const regenerate = useCallback(() => {
    const next = randomCode();
    setCode(next);
    setInput("");
    draw(canvasRef.current, next);
  }, []);

  useEffect(() => { regenerate(); }, [regenerate]);

  useEffect(() => {
    onChangeValid(input.trim().length > 0 && input.trim().toUpperCase() === code);
  }, [input, code, onChangeValid]);

  return (
    <div>
      <label className="label-mono block mb-2">Verify you're human</label>
      <div className="flex items-center gap-3">
        <canvas
          ref={canvasRef}
          width={160}
          height={56}
          data-testid="captcha-canvas"
          className="border-2 border-[#0A0A0A] rounded-xl"
          style={{ userSelect: "none" }}
          onContextMenu={(e) => e.preventDefault()}
        />
        <button
          type="button"
          onClick={regenerate}
          data-testid="captcha-refresh"
          aria-label="Refresh captcha"
          className="btn-brutal bg-white p-2"
        >
          <RefreshCw size={18} strokeWidth={2.5} />
        </button>
      </div>
      <input
        data-testid="captcha-input"
        required
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Enter the code shown above"
        autoComplete="off"
        className="mt-3 w-full px-4 py-3 border-2 border-[#0A0A0A] rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
  );
}
